import axios from 'axios';
import { MDBFileUpload } from 'mdb-react-file-upload';
import { MDBScrollStatus } from 'mdb-react-scroll-status';
import {
  MDBAccordion, MDBAccordionItem, MDBAlert, MDBAutocomplete,
  MDBBadge,
  MDBBtn, MDBCard,
  MDBCardTitle,
  MDBCheckbox, MDBCol,
  MDBFooter, MDBIcon, MDBInput, MDBInputGroup,
  MDBLightbox,
  MDBLightboxItem,
  MDBListGroup, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader,
  MDBModalTitle,
  MDBRow,
  MDBScrollbar,
  MDBSelect,
  MDBSpinner
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { CategoryContext } from '../context/CategoryContext';
import { DomainContext } from '../context/DomainProvider';
import { GeographyContext } from '../context/GeographyProvider';
import { NavbarContext } from '../context/NavProvider';
import { UserProfileContext } from '../context/UserProfileProvider';
import AddNewEntity from '../entity/AddNewEntity';
import Dropdown from '../reusables/Dropdown';
import { getDomainsAndCategories } from '../utils/Common';
import RecursiveParagraph from '../utils/RecursiveParagraph';
import EntityCreateModal from './../entity/EntityCreateModal';
import EntityDetailModal from './../entity/EntityDetailModal';
const Inventory = ({ isRequestUpdate,toggleItemAdded,  toggleUpdateRequestModal, requestId,  showCreateButton , setRefetchTrigger}) => {
  const containerElement = useRef(null);
 // const domainIdFromLocalStorage = localStorage.getItem('DOMAIN');
  const [modalOpen, setModalOpen] = useState(false);
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
 
  const [currentItem, setCurrentItem] = useState({ image: '', name: '', caption: '', subdomain: [], categoryIds: '', originalPrice: '', discountedPrice: '', buttonColor: '', currency: '', country: '', descriptions: [{ textValue: '',type:'', heading: { textValue: '', textColor: '', textSize: 'fs-2' }, paragraphs: [] }], features: [] });

  const [selectedDomain, setSelectedDomain] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [files, setFiles] = useState([]);
  const [isUploadDisabled, setIsUploadDisabled] = useState(true);
  const [viewItem, setViewItem] = useState(null);
  const [addNewModalOpen, setAddNewModalOpen] = useState(false);
  const [category, setCategory] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  
  const [loading, setLoading] = useState(true);
  const { domainId } = useParams(); 
  const {selectDomains,setSelectDomains,setGroupedDomainsByDomain,setDomainImages,setDomainId, setFirmId, firmId} = useContext(DomainContext);
  const {setGroupedCategoriesByDomain,setCategoryImages,categoryImages,selectCategories,setSelectCategories,} = useContext(CategoryContext);
  const {ipAddress, location,  currencies, currencyOptions,setCountry, country} = useContext(GeographyContext);
  const {tokenLoaded,groupedItems, setGroupedItems} = useContext(UserProfileContext)
  const {isPricing,  business, setBusiness} = useContext(NavbarContext);
  const navigate = useNavigate();
  const inventoryUrl = process.env.REACT_APP_INVENTORY_URL; 
  const [receiptImages, setReceiptImages] = useState([]);
  const [alertMessageForDeleteItemInCategoryVisible, setAlertMessageForDeleteItemInCategoryVisible] = useState(false);
  const [selectedDomainsStatus, setSelectedDomainsStatus] = useState({});
 
  const [searchValue, setSearchValue] = useState('');
  const [requestComplete, setRequestComplete] = useState(false);
  let [alertMessage, setAlertMessage] = useState("");
  const [alertVisible, setAlertVisible] = useState(false);
  const ref = useRef(null);
  const role = localStorage.getItem('ROLE');
  const isRoleUndefined = role === 'undefined';
  let alertProperties = {};
  let alertIcon = '';
  let alertBtn = '';

  const anyDomainSelectedForItem = itemId =>   Object.values(selectedDomainsStatus[itemId] || {}).some(Boolean);

  // Check if all selected items have at least one domain selected
  const isEverySelectedItemHasDomain = () =>  Object.keys(selectedItems).every(itemId => anyDomainSelectedForItem(itemId));

  // Check if there is an item selected that doesn't have a domain selected
  const isThereAnUnmatchedItem = () =>   Object.keys(selectedItems).some(itemId => !anyDomainSelectedForItem(itemId));

  // Condition for enabling the button when selectDomains is 1 and an item is selected
  const isSingleDomainWithItemSelected =   (selectDomains?.length === 1 && Object.keys(selectedItems)?.length > 0);

  // Condition for enabling the button when isRoleUndefined or isRequestUpdate and at least one item is selected
  const isRoleOrRequestConditionMet =    (isRoleUndefined || isRequestUpdate) && Object.keys(selectedItems)?.length > 0;

  const isButtonDisabled = !((isSingleDomainWithItemSelected) ||(isRoleOrRequestConditionMet) ||  (Object.keys(selectedItems)?.length > 0 && isEverySelectedItemHasDomain() &&  !isThereAnUnmatchedItem()) );
  const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
  const [isEntityCreateModalOpen, setIsEntityCreateModalOpen] = useState(false);

    useEffect(() => {
        if (selectDomains?.length === 0) {
            getDomainsAndCategories(firmId,location,ipAddress,tokenLoaded,setBusiness,setCountry,setSelectCategories,setSelectDomains,setGroupedCategoriesByDomain,setCategoryImages,setGroupedDomainsByDomain,setDomainImages,setDomainId, setFirmId);
            
        }
    }, []);
  
    const fetchItems = useCallback(async (domainIdf) => {
      try {
        let url = domainId ? `${inventoryUrl}/entities/domainId/${domainIdf || domainId || firmId}` : `${inventoryUrl}/entities`;
  
        let latLngQuery = "";
        if (location) {
          latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
        } else {
          latLngQuery = `?ipAddress=${ipAddress}`;
          if (!ipAddress) return;
        }
        url = url + latLngQuery;
        const response = await axios.get(url);
        let items = response.data;
        const categoryGroups = getCategoryGroups(items);
        setGroupedItems(Object.entries(categoryGroups).map(([category, items]) => ({ category, items })));
      } catch (error) {
        console.error("Error in fetchItems: ", error);
      } finally {
        setLoading(false);
      }
    }, []);
  
    function getCategoryGroups(items) {
      return items.reduce((groups, item) => {
        if (item.images && item.images.length > 0) {
          item.image = item.images[0];
        }
        if (item.categoryIdToName) {
          const primaryCategoryId = Object.keys(item.categoryIdToName)[0];
          const primaryCategoryName = item.categoryIdToName[primaryCategoryId];
          const categoryGroup = groups[primaryCategoryName] || [];
          categoryGroup.push(item);
          groups[primaryCategoryName] = categoryGroup;
        }
        return groups;
      }, {});
    }
  
   
  
    useEffect(() => {
      fetchItems();
    
    }, []);
    const allItems = groupedItems && groupedItems.flatMap(group => group.items.map(item => item.name));
    useEffect(() => {
      setIsUploadDisabled(!files || files.length === 0);
    }, [files]);
  


  const handleFilesChange = (e) => {
    if (files && files.length > 0) {
      const newFiles = [...files, ...e];
      setFiles(newFiles);
    } else {
      setFiles([...e]);
    }
  };

  useEffect(() => {

    if (!loading && !domainId && (!groupedItems || groupedItems.length === 0)) {
      navigate('/no-inventory');
    }
  }, [groupedItems, loading, navigate, domainId]); // Add loading to the dependencies



  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const toggleHistoryModal = () => {
    setHistoryModalOpen(!historyModalOpen);
  };


  const handleEdit = (item, category) => {

    item.category = category;
    setCurrentItem(item);
    setSelectedCategory(item.category);
    toggleModal();
  };

  const handleSave = async () => {
    if (currentItem) {
      const formData = new FormData();
      if (files && files.length > 0) {
        files.forEach((file) => {
          formData.append('images', file);
        });
      }

      const entity = {
        id: currentItem.id,
        firmId: currentItem.firmIds,
        name: currentItem.name,
        caption: currentItem.caption,
        originalPrice: currentItem.originalPrice,
        discountedPrice: currentItem.discountedPrice,
        categoryIds: currentItem.categoryIds,
        domainIds: currentItem.subdomain,  // Assumes that subdomain holds the domain ids
        descriptions: currentItem.descriptions,
        features: currentItem.features,
        buttonColor: currentItem.buttonColor,
        country: currentItem.country || country,
        isHistory: false
      };
      const entityData = new File([JSON.stringify(entity)], "entity", { type: "application/json" });
      formData.append('entity', entityData);
      let endpoint = `${inventoryUrl}/entities`;
      let latLngQuery = "";
      if (location) {
        latLngQuery = `?latitude=${location.latitude}&longitude=${location.longitude}`;
      } else {
        latLngQuery = `?ipAddress=${ipAddress}`;
      }
      endpoint = endpoint + latLngQuery;
      try {
        await axios.put(endpoint, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        }).then((response) => {
       
          const updatedItem = response.data;
          const updatedItems = groupedItems.map(group => ({
              ...group,
              items: group.items.map(item => (item.id === updatedItem.id ? updatedItem : item))
          }));
          setGroupedItems(updatedItems);
        
          setCurrentItem(null);
          setFiles(null); // Clear the files state after the successful API call
        });
      } catch (error) {
        console.error(error);
      }
    }

    toggleModal();
  };

  const handleSelectCategoryChange = (selected) => {
    if (selected) {
      //  let selectedValues = Array.isArray(selected) ? selected.map(item => item.value) : [selected.value];

      // Update both 'categories' and 'categoryIds' in the current item
      setCurrentItem(prevState => ({
        ...prevState,

        categoryIds: selected  // Assuming that the selected values are the category IDs
      }));
    } else {
      setCurrentItem(prevState => ({ ...prevState, categoryIds: [] }));
    }
    setSelectedCategory(selected);
  };


  const handleDeleteSelected = () => {
    const itemIdsToDelete = Object.keys(selectedItems);
    axios
      .delete(`${inventoryUrl}/entities`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: itemIdsToDelete,
        withCredentials: true,
      })
      .then((response) => {
        setAlertMessage('Items deleted successfully!');
        toggleAlertMessageForDeleteItemInCategory();
        setAlertMessageForDeleteItemInCategoryVisible(true);
        fetchItems();
      })
      .catch((error) => {
        console.error(error);
        setAlertMessage('Error!');
        toggleAlertMessageForDeleteItemInCategory();
        setAlertMessageForDeleteItemInCategoryVisible(true);
        fetchItems();
      });
      
  };

  const handleDelete = (id) => {
    axios
      .delete(`${inventoryUrl}/entities/${id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
      .then((response) => {
        setAlertMessage('Item deleted successfully!');
        toggleAlertMessageForDeleteItemInCategory();
        setAlertMessageForDeleteItemInCategoryVisible(true);
        fetchItems();
      })
      .catch((error) => {
        console.error(error);
        setAlertMessage('Error!');
        toggleAlertMessageForDeleteItemInCategory();
        setAlertMessageForDeleteItemInCategoryVisible(true);
        fetchItems();
      });
  };
  
  
  const toggleAlertMessageForDeleteItemInCategory = () => {
    setAlertMessageForDeleteItemInCategoryVisible(!alertMessageForDeleteItemInCategoryVisible);
    setTimeout(() => {
      setAlertMessageForDeleteItemInCategoryVisible(false);
    }, 3000);

  };

  const handleModalClose = () => {
    setCurrentItem({});
    toggleModal();

  };

 

  const toggleViewModal = () => {
    setViewModalOpen(!viewModalOpen);
  };

  const handleView = (item) => {
    setReceiptImages(null);
    setViewItem(item);
    toggleViewModal();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
    }
  };

  const toggleAddNewModal = (category) => {
    setAddNewModalOpen(!addNewModalOpen);
    setCategory(category);
  };

  const handleSelectItem = (itemId, e) => {
    const { checked } = e.target;

    // Update the selectedItems state
    setSelectedItems(prevState => {
      const newState = { ...prevState };
      if (checked) {
        newState[itemId] = true;
      } else {
        delete newState[itemId];
      }
      return newState;
    });

    // Extract domain names from selectDomains
    const allDomainNames = selectDomains.map(domain => domain.text);

    // Update the selectedDomainsStatus based on the checked status
    setSelectedDomainsStatus(prevState => {
      const updatedDomainsStatus = { ...prevState };
      allDomainNames.forEach(domain => {
        if (!updatedDomainsStatus[itemId]) {
          updatedDomainsStatus[itemId] = {};
        }
        updatedDomainsStatus[itemId][domain] = checked;
      });
      return updatedDomainsStatus;
    });
  };


  const handleSelectCategory = (e, items) => {
    const isChecked = e.target.checked;
    const itemIds = items.map(item => item.id);

    // Update selectedItems for every item in the category
    setSelectedItems(prevItems => {
      const newItems = { ...prevItems };
      itemIds.forEach(id => {
        if (isChecked) {
          newItems[id] = true;
        } else {
          delete newItems[id];
        }
      });
      return newItems;
    });

    // Update selectedDomainsStatus for every domain in every item
    setSelectedDomainsStatus(prevState => {
      const newDomainsStatus = { ...prevState };
      itemIds.forEach(id => {
        // For every domain of an item
        selectDomains.forEach(domain => {
          const labelName = domain.text;
          newDomainsStatus[id] = {
            ...newDomainsStatus[id],
            [labelName]: isChecked
          };
        });
      });
      return newDomainsStatus;
    });
  };

  const handleCheckboxChange = (itemId, e) => {
    const { name, checked } = e.target;


    setSelectedDomainsStatus(prevState => ({
      ...prevState,
      [itemId]: {
        ...(prevState[itemId] || {}),
        [name]: checked,
      }
    }));

  };

  useEffect(() => {
    if (selectDomains && selectDomains.length === 1) {
      const singleDomain = selectDomains[0];
      handleSelectDomainChange(singleDomain);
    }
  }, [selectDomains]);

  const handleSelectDomainChange = (selected) => {
    setCurrentItem(prevItem => ({ ...prevItem, subdomain: selected }));
    setSelectedDomain(selected);
  };

  const handleRequestSubmit = async () => {
    try {
      let response = {};

      if (requestId) {
        // Code for PUT
        const entityIds = [];
        const domainIds = new Set();
        const entityIdImageUrl = {};
        groupedItems.forEach(group => {
          group.items.forEach(item => {
            if (selectedItems[item.id]) {
              entityIds.push(item.id);

              if (selectedDomainsStatus[item.id]) {
                for (let domainName in selectedDomainsStatus[item.id]) {
                  if (selectedDomainsStatus[item.id][domainName]) {
                    const domainId = selectDomains.find(domain => domain.text === domainName).value;
                    domainIds.add(domainId);
                  }
                }
              }
            }
          });
        });

        const requestData = {
          entityIds: entityIds,
          entityIdImageUrl: entityIdImageUrl,
          domainIds: Array.from(domainIds),
        };

        response = await axios.put(`${inventoryUrl}/requests/${requestId}`, requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      
      ).then((response) => {
        setRefetchTrigger(true);
      });
      } else {


        // Code for POST
        const domainEntityMap = {};

        groupedItems.forEach(group => {
          group.items.forEach(item => {
            if (selectedItems[item.id]) {
              if (selectedDomainsStatus[item.id]) {
                for (let domainName in selectedDomainsStatus[item.id]) {
                  if (selectedDomainsStatus[item.id][domainName]) {
                    const domainId = selectDomains.find(domain => domain.text === domainName).value;

                    if (!domainEntityMap[domainId]) {
                      domainEntityMap[domainId] = [];
                    }

                    domainEntityMap[domainId].push(item);
                  }
                }
              } else {
                // Initialize the array if it doesn't exist yet
                if (!domainEntityMap[domainId]) {
                  domainEntityMap[domainId] = [];
                }

                domainEntityMap[domainId].push(item);
              }
            }
          });
        });

        response = await axios.post(`${inventoryUrl}/requests/createRequestByDomain`, domainEntityMap, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });
      }

      if (response.status === 200 || response.status === 201) {
        fetchItems();
        toggleRequestAlert();
      }

      console.log(response.data);
    } catch (error) {
      console.error(error);
    } finally {
      setSelectedDomainsStatus({});
      setSelectedItems([]);
    }
  };
 

  // 2. Update the search value whenever the input changes.
  const handleSearch = (value) => {
    setSearchValue(value);
  };

  // 3. Use the search value to filter the items.
  const filteredItems = useMemo(() => {

    if (!searchValue) {
      return groupedItems;
    }

    return groupedItems && groupedItems.map(group => ({
      ...group,
      items: group.items.filter(item => item.name.toLowerCase().startsWith(searchValue.toLowerCase())),
    })).filter(group => group.items.length > 0);
  }, [groupedItems, searchValue]);

  const toggleAlertVisible = () => {
    setAlertVisible(!alertVisible);

  };


  const toggleRequestAlert = () => {
    setRequestComplete(!requestComplete);

    setTimeout(() => {
      setRequestComplete(false);
    }, 3000);
  };



  if (requestComplete) {
    alertProperties = {
      open: true,
      className: 'w-100',
      color: 'success',
      onClick: toggleRequestAlert,
    };
    alertIcon = 'fas fa-check-circle me-3';
    alertBtn = (
      <MDBBtn color='link' rippleColor='dark'>
        close
      </MDBBtn>
    );
    alertMessage = requestId ? 'Request updated successfully' : 'Request created successfully';
  } else if (alertVisible) {
    alertProperties = {
      open: true,
      className: 'm-1',
      color: 'success',
      onClick: toggleAlertVisible,
    };
    alertIcon = 'fas fa-check-circle me-3';
    alertBtn = (
      <MDBBtn color='link' rippleColor='dark' onClick={toggleAlertVisible}>
        close
      </MDBBtn>
    );
  } else if (alertMessageForDeleteItemInCategoryVisible) {
    alertProperties = {
      open: true,
      className: 'm-1',
      color: 'success',
      onClick: toggleAlertMessageForDeleteItemInCategory,
    };
    alertIcon = 'fas fa-check-circle me-3';
    alertBtn = (
      <MDBBtn color='link' rippleColor='dark' onClick={toggleAlertMessageForDeleteItemInCategory}>
        close
      </MDBBtn>
    );
  }


  

  const handleIsEntityCreateModalOpenToggle = () => {
    setIsEntityCreateModalOpen(!isEntityCreateModalOpen);
  };
 
  const handleRemoveThumbnail = (index) => {
    const newThumbnails = currentItem.thumbnails.filter((_, i) => i !== index);
    const newImageIds = currentItem.imageIds.filter((_, i) => i !== index);
    setCurrentItem((prevItem) => ({
      ...prevItem,
      thumbnails: newThumbnails,
      imageIds: newImageIds
    }));
  };

  const [textData, setTextData] = useState(currentItem?.descriptions || currentItem?.paragraphDescriptions ||  []);

  // Sync textData from currentItem.descriptions
  useEffect(() => {
    setTextData(currentItem?.descriptions|| currentItem?.paragraphDescriptions ||  []);
  }, [currentItem]);

  // Sync textData changes to currentItem globally
  useEffect(() => {
    setCurrentItem((prevState) => ({
      ...prevState,
      descriptions: textData,
    }));
  }, [textData, setCurrentItem]);

  const handleAddDescription = useCallback(() => {
    const newDescription = {
      id: uuidv4(),
      textValue: '',
      textColor: 'black',
      textSize: 'h5',
      fontSize: 'fs-6',
      type: 'caption',
      orderNumber: (textData.length || 0) + 1,
      paragraphs: [],
      heading: {
        id: uuidv4(),
        textValue: '',
        textColor: 'black',
        textSize: 'h2',
        fontSize: 'fs-4',
        type: 'caption',
      },
    };

    setTextData((prevTextData) => [...prevTextData, newDescription]);
  }, [textData]);

  const memoizedRecursiveParagraph = useMemo(
    () => (
      <RecursiveParagraph
        featureName={currentItem?.name || ''}
        textData={textData}
        setCurrentItem={setCurrentItem} // Directly pass setCurrentItem
        setTextData={setTextData}
        contextType="paragraphDescriptions"
      />
    ),
    [textData, setCurrentItem, currentItem?.name]
  );


  
  
 
 

  
  const handleFeatureChange = (featureIndex, property, value) => {
    setCurrentItem(prevState => {
      const newFeatures = [...prevState.features]; // Create a copy of features array
      newFeatures[featureIndex][property] = value; // Update the specific feature property
      return { ...prevState, features: newFeatures }; // Update the currentItem with the modified features array
    });
  };


  
  
  
  const handleAddFeature = () => {
    setCurrentItem(prevState => ({
      ...prevState,
      features: prevState.features ? [...prevState.features, { textValue: '', textColor: '', icon: '' }] : [{ textValue: '', textColor: '', icon: '' }]
    }));
  };

  
 

  const handleRemoveFeature = (featureIndex) => {
    setCurrentItem(prevItem => {
      const newFeatures = [...prevItem.features]; // Shallow copy of the features array
      newFeatures.splice(featureIndex, 1); // Remove the feature at featureIndex
      return { ...prevItem, features: newFeatures }; // Update the features array within currentItem
    });
  };
  


  const getCurrencySymbol = (currencyCode) => {
    const currency = currencies.find(c => c.country === currencyCode);
    return currency ? currency.symbol : currencyCode;
  };

 
  
  const renderAccordionItems = (itemsToRender) => itemsToRender && itemsToRender.length > 0 && itemsToRender.map(({ category, items }, index) => (

    <MDBAccordionItem  
      key={`${category}-${index}`}
      collapseId={`collapse-${category}-${index}`}

      headerTitle={
        <div className="d-flex justify-content-start justify-content-md-center align-items-center text-lowercase">
          <div className="d-flex align-items-left text-capitalize">
            {categoryImages && categoryImages[category]  && <img src={categoryImages && categoryImages[category]} alt="" style={{ width: '40px', height: '40px', marginRight: '10px' }} className='rounded'/>}
            <a href='#!'>
              <MDBBadge color='light' light>
                <h6 className='text-capitalize' style={{ color: 'red' }}>{category}</h6>
              </MDBBadge>
              <MDBBadge color='danger' notification pill>
                {items?.length}
              </MDBBadge>
            </a>
          </div>
        </div>
      }
      >
      <MDBListGroup light className="mb-4 text-lowercase">
        {items.map((item, itemIndex) => (
          <div key={`${item.id}-${itemIndex}`} className={` justify-content-between align-items-center ${itemIndex !== items.length - 1 ? 'border-bottom pb-3 mb-1' : ''}`} style={{ color: 'hsl(218, 81%, 35%)', fontSize: '16px', textDecoration: 'none' }}>
            <div className="d-flex align-items-center flex-wrap " >
              {item.imageIds && item.imageIds.length > 0 && !item.imageIds[0].includes('test') && (
    <div className="ms-3 me-2">
      <img
        src={item.thumbnails[item?.imageIds?.length - 1]} // Accessing the last image in the thumbnails array
        alt=""
        style={{ width: '40px', height: '40px' }}
        className='rounded'
      />
    </div>
  )}
              <span className="fw-bold mb-1 me-2  text-capitalize "> {item && item.name ? item.name : ''}</span> 
             
             
          {item.historyId &&    <div className="ms-5 d-flex flex-grow-1 justify-content-end">
               
                <figcaption className='blockquote-footer mb-0' >
        Total Spent <cite title='totalSpent'> <span >{item?.currencySymbol || ''}</span>
        <span className='text-black'>{item?.totalPrice || ''}</span></cite>
      </figcaption>

              </div>}
              <div className="ms-5">


                {domainId && <span className="fw-bold mb-1 me-2  text-capitalize ">

                  {business === 'B2C' &&
                    (item.allPrices ?
                      <p className="fw-light ms-2">
                        Prices: {Object.entries(item.allPrices).map(([currencyCode, price]) => `${getCurrencySymbol(currencyCode)}${price}`).join(", ")}
                        {item.allDiscountedPrices &&
                          <p> Discounted Prices: {Object.entries(item.allDiscountedPrices).map(([currencyCode, discountedPrice]) => `${getCurrencySymbol(currencyCode)}${discountedPrice}`).join(", ")}</p>
                        }
                      </p>
                      :
                      <p className="fw-light ms-2">
                        Price : {getCurrencySymbol(item.currencyCode)}{item.originalPrice}
                      </p>
                    )
                  }
                </span> }

                <MDBScrollbar>

                  {/* {selectDomains && selectDomains?.length === 0 &&
                    <div className='d-flex justify-content-center'>
                      <MDBSpinner color='warning'>
                        <span className='visually-hidden'>Loading...</span>
                      </MDBSpinner>
                    </div>
                  } */}
                {
  !isRoleUndefined && selectDomains && selectDomains?.length > 1 && selectDomains.map((domain, index) => {
    const labelName = domain.text;
    const itemId = item.id;
    const isChecked = selectedDomainsStatus[itemId] && selectedDomainsStatus[itemId][labelName];
    const shouldShowCheckbox = domainId ? domain.value === domainId : true;

    return (
      shouldShowCheckbox && (
        <div key={index} className='d-flex align-items-start'>
          {(showCreateButton || isRequestUpdate) ? (
            <div className="p-1">
              <MDBCheckbox
                name={labelName}
                value={domain.value}
                id={`flexCheck${index}`}
                label={<span className='text-capitalize'>{labelName}</span>}
                onChange={(e) => handleCheckboxChange(itemId, e)}
                checked={isChecked || false}
              />
            </div>
          ) : (
            <p className='text-capitalize ms-2'>{labelName}</p>
          )}
        </div>
      )
    );
  })
}

                </MDBScrollbar>

              </div>
            </div>



            <MDBRow className='justify-content-center  align-items-center'>

  <MDBInputGroup className='w-100 justify-content-center rounded   align-items-center'>

    {(domainId || showCreateButton || isRequestUpdate)  &&(
      <MDBCol xs='12' sm='6' md='6' lg='auto'>
        <MDBCheckbox
          name={`checkNoLabel-${index}-${item.id}`}
          id={`checkNoLabel-${index}-${item.id}`}
          value=""
          label={selectDomains.length > 1 ? 'Select All' : ""}
          aria-label="..."
          wrapperStyle={{ color: 'red' }}
          onChange={(e) => handleSelectItem(item.id, e)}
          checked={selectedItems[item.id] || false}
        />
      </MDBCol>
    )}
  {item?.historyId &&  <MDBCol xs='12' sm='6' md='6' lg='auto'>
      <MDBBtn size="sm" rounded color="link" onClick={() => {
        setModalOpen(false);
        setIsSecondModalOpen(true);
        handleView(item)
      }}>
        View
      </MDBBtn>
    </MDBCol>}
    {domainId && (
      <>
        {/* Conditionally render Edit and Delete buttons for larger screens */}
        <MDBCol xs='12' sm='6' md='6' lg='auto' >
          <MDBBtn size="sm" rounded color="link" onClick={() => handleEdit(item, category)}>
            Edit
          </MDBBtn>
        </MDBCol>
        <MDBCol xs='12' sm='6' md='6' lg='auto'>
          <MDBBtn size="sm" rounded color="link" onClick={() => handleDelete(item.id)}>
            Delete
          </MDBBtn>
        </MDBCol>
      </>
    )}
  </MDBInputGroup>
</MDBRow>


          </div>
        ))}
      </MDBListGroup>
      {(domainId || showCreateButton) && (items?.length > 1) && <hr className="hr" />}
      {items.length >= 1 && (
        <MDBFooter bgColor='blue' className='text-center text-lg-left'>
          <MDBRow className='row-cols-1 row-cols-md-4 g-2 mt-2'>
            {/* <MDBInputGroup className='justify-content-center flex-nowrap'> */}
            <MDBInputGroup className='w-100 justify-content-center flex-nowrap gap-2'>
              {((domainId || showCreateButton || isRequestUpdate) && items?.length > 1) ?
                <MDBCol key={`category-${index}`} xs='12' sm='6' md='6' lg='auto'>
                  <MDBCheckbox
                    name={`checkNoLabel-category-${index}`}
                    id={`checkNoLabel-category-${index}`}
                    value=""
                    aria-label="..."
                    wrapperclassname="me-2"
                    onChange={(e) => handleSelectCategory(e, items)}
                    checked={items?.every((item) => selectedItems[item.id])}

                  /> </MDBCol> : null}
              {(domainId && items?.length > 1 )&&
                <MDBCol key={index} xs='12' sm='6' md='6' lg='auto'>
                  <MDBBtn color="danger" className="responsive-button text-nowrap " onClick={handleDeleteSelected}>
                    Delete Selected
                  </MDBBtn></MDBCol>
              }
              {domainId &&

                <MDBCol key={index} xs='12' sm='6' md='6' lg='1'>
                  <MDBBtn className="responsive-button" onClick={() => toggleAddNewModal(category)}>
                    Add
                  </MDBBtn>
                </MDBCol>

              }
            </MDBInputGroup>
          </MDBRow>
        </MDBFooter>
      )}
    </MDBAccordionItem>
  ));
 


  return (
    loading ? (
      <div className='d-flex m-5 justify-content-center' >
        <MDBSpinner style={{ width: '3rem', height: '3rem' }}>
          <span className='visually-hidden'>Loading...</span>
        </MDBSpinner>
      </div>
    ) :


   

<section className="d-flex mb-2 mt-2 grainy-gradient-intro justify-content-center text-center "  >

{handleIsEntityCreateModalOpenToggle && <EntityCreateModal fetchItems={fetchItems}
          isEntityCreateModalOpen={isEntityCreateModalOpen}
          handleIsEntityCreateModalOpenToggle={handleIsEntityCreateModalOpenToggle}
          toggleItemAdded={toggleItemAdded}
          enableGoToInventory={allItems?.length > 0} />}


        {(allItems?.length > 0 || domainId) &&


          <MDBCard  className='align-items-center d-flex col-12 col-md-8 col-lg-6 mx-auto' >
            <MDBCardTitle>  <h2 className="display-7 fw-bold text-uppercase text-success mb-0 mt-2" style={{ letterSpacing: "3px" }}>{showCreateButton ? 'Requests' : 'Inventory'}</h2> </MDBCardTitle>
            <>
              <div className="d-flex justify-content-center mt-2 col-12 col-md-8 col-lg-6 mx-auto" >
                <MDBInputGroup style={{ maxWidth: '550px', width: '100%', color: "primary", marginBottom: "", }}>
                  <MDBAutocomplete

                    label='Type an item'
                    data={allItems}
                    onChange={handleSearch}
                    labelStyle={{ color: 'success' }} />
                  <MDBBtn rippleColor='white' style={{ position: 'relative' }}>
                    <span>
                      <MDBIcon fas icon='search' />
                    </span>
                    <span style={{ position: 'absolute', top: 0, right: 0 }}>
                      <MDBBadge color='danger' notification pill>
                        {allItems?.length}
                      </MDBBadge>
                    </span>
                  </MDBBtn>
                </MDBInputGroup>
              </div>

              <section className="grainy-gradient-intro col-12 col-md-8 col-lg-6 mx-auto" style={{ marginTop: '10px'}}  >

                {alertProperties.open && (
                  <MDBAlert {...alertProperties} >
                    <i className={alertIcon}></i>{alertMessage}
                    {alertBtn}
                  </MDBAlert>
                )}
                {loading ? (
                  <MDBSpinner className='mx-2 ' color='info'>
                    <span className='visually-hidden'>Loading...</span>
                  </MDBSpinner>
                ) : null}
                <div style={{ margin: '0 auto' }} ref={ref} className='ms-2 me-2' >
                  <MDBScrollStatus containerRef={ref} />
                  <MDBAccordion alwaysOpen initialActive={`collapse-${category}-0`} style={{ zIndex: 12, overflow: 'visible' }}>

                    {filteredItems
                      ? renderAccordionItems(filteredItems)
                      : renderAccordionItems(groupedItems)}
                  </MDBAccordion>
                  {!loading && (
                    <div>

                      <MDBRow  className='text-center rounded mt-3 gy-2 gx-3 align-items-center'>
                        <MDBCol className='d-flex justify-content-center'>
                          {domainId ? (
                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '75px' }}>
                              <MDBBtn type="button" className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2" color='primary' onClick={() => toggleAddNewModal('')}>
                                Add Item(s)
                              </MDBBtn>
                              <MDBBtn type="button" color='dark' size='xl' className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2" onClick={handleIsEntityCreateModalOpenToggle}>
                                BULK UPLOAD
                              </MDBBtn>
                            </div>
                          ) : (
                            (showCreateButton || isRequestUpdate) &&
                            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                              <MDBBtn className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2" color='success' onClick={handleRequestSubmit} style={{ marginTop: '20px' }} disabled={isButtonDisabled}>
                                {isRequestUpdate ? 'Update' : 'Create'}
                              </MDBBtn>
                              {toggleUpdateRequestModal &&
                                <MDBBtn className="btn-lg py-3 px-5 mb-2 mb-md-4 me-md-2" type='button' color='link' onClick={toggleUpdateRequestModal}>
                                  close
                                </MDBBtn>}
                            </div>

                          )}

                        </MDBCol>
                      </MDBRow>

                    </div>
                  )}
                </div>
                {!isRequestUpdate &&
                  <AddNewEntity
                    key={`AddNewEntity-${addNewModalOpen}`}
                    show={addNewModalOpen}
                    handleAddModalClose={toggleAddNewModal}
                    fetchItems={fetchItems}
                    toggleAlertVisible={toggleAlertVisible}
                    setAlertMessage={setAlertMessage}
                    setAlertVisible={setAlertVisible}
                    handleIsEntityCreateModalOpenToggle={toggleAddNewModal}
                    selectDomains={selectDomains}
                    selectCategories={selectCategories}
                    setAddNewModalOpen={setAddNewModalOpen}
                    category={category}
                    domain={domainId} />}

{/* <MDBDraggable container={ref} className='shadow-1-strong' draggingClass='shadow-3-strong'> */}
             
<MDBModal
  key={`MDBModal-${modalOpen}`}
  className='modal-backdrop.show'
  open={modalOpen}
  onClick={handleBackdropClick}
  toggle={handleModalClose}
  backdrop='static'
  onClose={handleModalClose}
>
  <MDBModalDialog centered={true} size="xl">
    <MDBModalContent>
      <MDBModalHeader toggle={handleModalClose}>
        <MDBModalTitle>{currentItem ? 'Edit Item' : 'New Item'}</MDBModalTitle>
        <MDBBtn className='btn-close' color='none' onClick={handleModalClose}></MDBBtn>
      </MDBModalHeader>
      <MDBModalBody>
        <MDBInput
          label='Name *'
          value={currentItem ? currentItem.name : ''}
          onChange={(e) => setCurrentItem((prevItem) => ({ ...prevItem, name: e.target.value }))}
        />
         <MDBInput
          label='Caption'
          value={currentItem ? currentItem.caption : ''}
          onChange={(e) => setCurrentItem((prevItem) => ({ ...prevItem, caption: e.target.value }))}
        />
        <Dropdown
          label="Domain *"
          name="subdomain"
          dataForDropDown={selectDomains}
          onValueChange={(selected) => handleSelectDomainChange(selected)}
          selected={selectedDomain}
          setSelected={setSelectedDomain}
        />
        <Dropdown
          label="Category *"
          name="categories"
          dataForDropDown={selectCategories}
          onValueChange={(selected) => handleSelectCategoryChange(selected)}
          defaultValue={currentItem?.category}
          selected={selectedCategory}
          setSelected={setSelectedCategory}
        />
  {!currentItem?.historyId &&                        <>
                          <MDBInput label='Price' id='typeNumber' name='price' type='number' className='mt-2' value={currentItem?.originalPrice} onChange={(e) => setCurrentItem((prevItem) => ({ ...prevItem, originalPrice: e.target.value }))} />
                            <MDBInput label='DiscountedPrice' name='discountedPrice' id='typeNumber' type='number' className='mt-2' value={currentItem?.discountedPrice} onChange={(e) => setCurrentItem((prevItem) => ({ ...prevItem, discountedPrice: e.target.value }))} />
                          {isPricing &&   <MDBInput label='ButtonColor' name='buttonColor' id='btnColor' type='string' className='mt-2' value={currentItem?.buttonColor} onChange={(e) => setCurrentItem((prevItem) => ({ ...prevItem, buttonColor: e.target.value }))} />}

                            <MDBSelect
                              name='Currency'
                              label='Currency'
                              id='currency'
                              type='text'
                              className='mt-2'
                              data={currencyOptions}
                              visibleOptions={5}
                              onValueChange={(selectedValue) => {
                                console.log(selectedValue);
                                const selectedCurrency = currencies.find(currency => `${currency?.country} (${currency?.symbol})` === selectedValue?.text);
                                if (selectedCurrency) {
                                  setCurrentItem(prevItem => ({
                                    ...prevItem,
                                    currency: selectedCurrency?.currencyName,
                                    country: selectedCurrency?.country
                                    // ... you can also set other properties like symbol, unit if needed
                                  }));
                                }
                              }}

                            />  
        {/* Thumbnails Section */}
        <h4 className="mt-4">Images</h4>
          {currentItem?.imageIds?.length > 0 && (
            <MDBRow>
              {currentItem.imageIds.map((thumbnail, index) => (
                
                <MDBCol key={`images-${index}`} xs="6" md="3" className="text-center "> 
     
                  {/* <img
                    src={thumbnail}
                    alt={`thumbnail-${index}`}
                    className="img-fluid mb-2 rounded"
                    style={{ maxWidth: '50px', maxHeight: '50px' }}
                  /> */}
  <MDBLightbox className='position-relative'>
  <MDBLightboxItem
                  src={thumbnail}
                  alt={`thumbnail-${index}`}
                  className="img-fluid mb-2 rounded "
                    style={{ maxWidth: '100px', maxHeight: '100px' }}
                  />
                   <MDBBtn
                    size="sm"
                    color="link" 
                    className="position-absolute top-0 end-0 translate-middle"
                    onClick={() => handleRemoveThumbnail(index)}
                  >
                    <MDBIcon fas icon="trash-alt" style={{ color: '#000000' }}/>
                  </MDBBtn>
                  </MDBLightbox>
                 
                </MDBCol>
              ))}
            </MDBRow>
          )}

<div className="mb-2 mt-2 text-center align-items-center justify-content-center">


          <MDBRow className="align-items-center mb-3">
            <section className="mx-auto position-relative" style={{ marginTop: '10px' }}>
              <section>{memoizedRecursiveParagraph}</section>
            </section>
          </MDBRow>

          <MDBBtn
            type="button"
            color="success"
            onClick={handleAddDescription}
          >
            Add Description
          </MDBBtn>
        
    </div>


        </>
}
{isPricing && 
<div>
{currentItem?.features?.length > 0 && currentItem.features?.map((feature, featureIndex) => (
  <div key={featureIndex} className='position-relative text-black rounded-5 bg-success p-2 text-dark bg-opacity-10 mt-2'>
    <h3 className='text-primary'>{`Feature: ${featureIndex + 1}`}</h3>
    <MDBInput
      label='Text Value'
      id={`form${featureIndex + 1}`}
      type='text'
      value={feature.textValue || ''}
      style={{ marginTop: '12px' }}
      onChange={(e) => handleFeatureChange(featureIndex, 'textValue', e.target.value)}
    />
    <MDBInput
      label='Text Color'
      id={`form${featureIndex + 1}`}
      type='text'
      value={feature.textColor || ''}
      style={{ marginTop: '12px' }}
      onChange={(e) => handleFeatureChange(featureIndex, 'textColor', e.target.value)}
    />
    <MDBInput
      label='Icon'
      id={`form${featureIndex + 1}`}
      type='text'
      value={feature.icon || ''}
      style={{ marginTop: '12px' }}
      onChange={(e) => handleFeatureChange(featureIndex, 'icon', e.target.value)}
    />
    <MDBBadge color='none' light pill className='position-absolute top-0 start-100 translate-middle p-2'>
      <MDBBtn className='ms-2' tag='a' color='none' floating onClick={() => handleRemoveFeature(featureIndex)}>
        <MDBIcon fas icon="trash-alt" />
      </MDBBtn>
    </MDBBadge>
  </div>
))}

<MDBBtn className='mt-3' size='sm' color='primary' onClick={handleAddFeature}>
  Add Feature
</MDBBtn>
</div> }
<MDBFileUpload multiple maxFileSize='2M' onChange={handleFilesChange} style={{ marginTop: '12px' }} disabled={isUploadDisabled} />
                        
      </MDBModalBody>
      <MDBModalFooter>
        <MDBBtn size='sm' color='success' onClick={handleModalClose}>
          Close
        </MDBBtn>
        <MDBBtn
          size='sm'
          color='primary'
          onClick={handleSave}
          disabled={(!currentItem?.name || !currentItem?.category)}
        >
          Save changes
        </MDBBtn>
      </MDBModalFooter>
    </MDBModalContent>
  </MDBModalDialog>
</MDBModal>

                  {/* </MDBDraggable> */}
                
<EntityDetailModal isSecondModalOpen={isSecondModalOpen} setIsSecondModalOpen={setIsSecondModalOpen} viewItem={viewItem} setViewItem={setViewItem}/>

              </section>
            </>

          </MDBCard>
        }


      </section>


  );



};

Inventory.propTypes = {

  isRequestUpdate: PropTypes.bool,
  showCreateButton: PropTypes.bool,
  itemAdded: PropTypes.bool,
  toggleItemAdded: PropTypes.func,
  domainId: PropTypes.string,
  toggleUpdateRequestModal: PropTypes.func,
  selectDomains: PropTypes.array,
  selectCategories: PropTypes.array,
  onDomainsUpdate: PropTypes.func,
  groupedItems: PropTypes.array,
  groupedItemsByDomain: PropTypes.array,
  fetchItems: PropTypes.func,
  showWait: PropTypes.bool,
  requestId: PropTypes.string,
  categoryImages: PropTypes.object,
  setRefetchTrigger: PropTypes.func,

};

export default Inventory;
